import {
  Button,
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
  Meter,
  QueryState,
  TOUCH,
} from "@nymbl/nos2-rules";
import { Link } from "@tanstack/react-router";
import { useMonthDemands } from "@/hooks/use-month";
import { planVsLogged } from "@/lib/month/metrics";
import { type MonthKey, monthLabel } from "@/lib/month/month";

/** The six demands with the most guidance hours: "9 of 40 hrs". Full list on Guidance. */
export function PlanPanel({ month }: { month: MonthKey }) {
  const demands = useMonthDemands(month);
  return (
    <Card>
      <CardHeader>
        <CardTitle>
          <h2 className="font-display text-lg font-bold">Guidance vs logged</h2>
        </CardTitle>
        <CardAction>
          <Button asChild variant="link" className={TOUCH}>
            <Link
              to="/dashboard/guidance"
              search={{ month }}
              aria-label={`Open Guidance for ${monthLabel(month)}`}
            >
              Guidance
            </Link>
          </Button>
        </CardAction>
      </CardHeader>
      <CardContent>
        <QueryState query={demands}>
          {(rows) => {
            const bars = planVsLogged(rows);
            if (bars.length === 0)
              return <p className="text-sm text-muted-foreground">No guidance</p>;
            return (
              <ul className="flex flex-col gap-3">
                {bars.map((b) => (
                  <li key={b.id} className="flex flex-col gap-1.5">
                    <div className="flex justify-between gap-3 text-sm">
                      <span className="min-w-0 truncate font-semibold">{b.name}</span>
                      <span className="whitespace-nowrap text-muted-foreground">{b.label}</span>
                    </div>
                    <Meter
                      ratio={b.over ? 1.01 : b.ratio}
                      overTone="warning"
                      hideLabel
                      label={`${b.name}: ${b.label}`}
                    />
                  </li>
                ))}
              </ul>
            );
          }}
        </QueryState>
      </CardContent>
    </Card>
  );
}
